import { X, AlertTriangle } from 'lucide-react';

interface LocatorRequiredModalProps {
  isOpen: boolean;
  onClose: () => void;
}

/**
 * Modal shown when a child relationship path is selected without a locator
 */
const LocatorRequiredModal = ({ isOpen, onClose }: LocatorRequiredModalProps) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-xl p-6 max-w-2xl w-full mx-4 flex flex-col">
        <div className="flex justify-between items-center mb-4">
          <div className="flex items-center text-red-600">
            <AlertTriangle className="h-6 w-6 mr-2" />
            <h2 className="text-xl font-bold text-slate-900">Locator Required</h2>
          </div>
          <button
            onClick={onClose}
            className="text-slate-400 hover:text-slate-600 transition-colors"
          >
            <X className="h-6 w-6" />
          </button>
        </div>
        <div className="mb-6 space-y-2">
          <p className="text-slate-700">
            The final object in your path is a child relationship. A locator must be specified to
            identify which child record should be used.
          </p>
          <p className="text-slate-500 text-sm">
            Please add a locator (such as by field value or list position) before confirming this
            mapping.
          </p>
        </div>
        <div className="mt-auto flex justify-end pt-4 border-t border-slate-200">
          <button
            onClick={onClose}
            className="px-4 py-2 border border-slate-300 rounded-md text-slate-700 hover:bg-slate-50 transition-colors"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default LocatorRequiredModal;
